import { render, staticRenderFns } from "./CreateWorkPermit.vue?vue&type=template&id=6a0b055e&scoped=true&"
import script from "./CreateWorkPermit.vue?vue&type=script&lang=js&"
export * from "./CreateWorkPermit.vue?vue&type=script&lang=js&"
import style0 from "./CreateWorkPermit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CreateWorkPermit.vue?vue&type=style&index=1&id=6a0b055e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0b055e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a0b055e')) {
      api.createRecord('6a0b055e', component.options)
    } else {
      api.reload('6a0b055e', component.options)
    }
    module.hot.accept("./CreateWorkPermit.vue?vue&type=template&id=6a0b055e&scoped=true&", function () {
      api.rerender('6a0b055e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/CreateWorkPermit.vue"
export default component.exports